// tslint:disable
import { Component, Injector } from "@angular/core";

import { CMFormEditComponent, CMInputConfig } from "./../../@cmcore/component";

@Component({
  selector: "grupodeoperacao-edit",
  templateUrl: "grupodeoperacao-edit.component.html",
})
export class GrupoDeOperacaoEditComponent extends CMFormEditComponent {
  getFirstComponentName() {
    return "model_codigo";
  }

  getTitle() {
    return "Grupo de Operação";
  }

  constructor(_injector: Injector) {
    super(_injector);
    this.controllerName = "grupodeoperacao";
    this.modelConfig = {
      codigo: new CMInputConfig({
        form: this,
        caption: "Código",
        maxlength: 5,
        required: true,
        upper: true,
        disabledFunc: () => {
          return this.model.codigo == "GERAL" || this.model.codigo == "SAT";
        },
      }),
      descricao: new CMInputConfig({
        form: this,
        caption: "Descrição",
        required: true,
        maxlength: 60,
      }),
    };
  }
}
